import EChart, { EChartsOption } from 'echarts-for-react';
import { useIntl } from 'react-intl';

import { getRiskLevel, getYAxisLabels } from './utils';

import { ChartProps } from './types';

import * as S from './styles';

const MAX_Y_AXIS_LABELS = 4;

const options: EChartsOption = {
  dataZoom: [
    {
      zoomLock: false,
      top: '90%',
      height: 0,
      moveHandleIcon: 'image://',
      moveHandleSize: 12,
      moveHandleStyle: {
        borderWidth: 0,
        color: '#9898A6',
      },
    },
  ],
  grid: {
    top: 6,
    right: 25,
    bottom: 80,
  },
  xAxis: {
    boundaryGap: false,
    offset: 10,
    axisLabel: {
      fontSize: 12,
      color: '#6B6B78',
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: '#f5f5f5',
      },
    },
    type: 'category',
  },
  yAxis: {
    offset: 3,
    boundaryGap: false,
    axisLine: {
      show: false,
      lineStyle: {
        color: '#f5f5f5',
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: '#D7D7E0',
      },
    },
    axisLabel: {
      fontSize: 14,
      color: '#6B6B78',
    },
    type: 'category',
  },
  color: '#710252',
  series: [
    {
      symbolSize: 13,
      symbol: 'circle',
      type: 'line',
    },
  ],
};

export function Chart({ type, results }: ChartProps) {
  const intl = useIntl();

  function getOptions() {
    const yAxis = getYAxisLabels(type).map(label =>
      intl.formatMessage({ id: label }),
    );

    const xAxis = results.map(result =>
      new Date(result.date).toLocaleDateString(intl.locale, {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
      }),
    );

    const dataZoom = [
      {
        ...options.dataZoom[0],
        maxValueSpan: 3,
        startValue: results.length - MAX_Y_AXIS_LABELS,
      },
    ];

    const series = results.map((result, index) => [
      index,
      getRiskLevel(type)[result.description].level,
    ]);

    const hideDataZoom = results.length <= MAX_Y_AXIS_LABELS;

    return {
      ...options,
      tooltip: {
        trigger: 'item',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        formatter: (params: any) => {
          return `${results[params.data[0]].score}`;
        },
        className: 'chart-tooltip',
      },
      xAxis: {
        ...options.xAxis,
        data: xAxis,
      },
      dataZoom: hideDataZoom ? [] : dataZoom,
      grid: {
        ...options.grid,
        left: 85,
      },
      yAxis: {
        ...options.yAxis,
        data: yAxis,
      },
      series: [
        {
          ...options.series[0],
          data: series,
        },
      ],
    };
  }

  return (
    <S.Wrapper maxWidth="354px">
      <EChart
        option={getOptions()}
        notMerge
        style={{
          height: '250px',
        }}
      />
    </S.Wrapper>
  );
}
